import { render, staticRenderFns } from "./VisitErrorNotificationContainer.vue?vue&type=template&id=1e23b0b6&scoped=true"
import script from "./VisitErrorNotificationContainer.vue?vue&type=script&lang=ts"
export * from "./VisitErrorNotificationContainer.vue?vue&type=script&lang=ts"
import style0 from "./VisitErrorNotificationContainer.vue?vue&type=style&index=0&id=1e23b0b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e23b0b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e23b0b6')) {
      api.createRecord('1e23b0b6', component.options)
    } else {
      api.reload('1e23b0b6', component.options)
    }
    module.hot.accept("./VisitErrorNotificationContainer.vue?vue&type=template&id=1e23b0b6&scoped=true", function () {
      api.rerender('1e23b0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/VisitErrorNotificationContainer.vue"
export default component.exports